// Le responsable pédagogique voit les dossiers financeurs / clients mais ni les coûts de la prestation ni les factures
export const peutVoirCouts = (user) => user?.role !== 'responsable_pedagogique';
